import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete, Checkbox, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { camelCase_to_Sentence, toTitleCase } from '../../../../../helpers/format';
import { AutosizedPopper } from '../../../../common/AutosizedPopper';
import { AutosizedTextField } from '../../../../common/AutosizedTextField';
import { Arbitrator, AttributeModiferKeys } from './Arbitrator';
const INITIAL = null;
export const EnumerationAttribute = (props) => {
    const { name, attribute, rangeLimits, disable, isRoot } = props;
    const [checked, setChecked] = useState(false);
    const [selected, setSelected] = useState(INITIAL);
    const disabled = isRoot ? !checked : disable;
    useEffect(() => {
        if (disabled)
            setChecked(false);
        if (selected !== INITIAL && disabled)
            setSelected(INITIAL);
    }, [disabled, selected]);
    const more = [];
    const payload = {};
    let valid = !disabled;
    const { attributeType, enumeration, ...others } = rangeLimits;
    for (const [key, other] of Object.entries(others)) {
        if (!AttributeModiferKeys.includes(key)) {
            const { elements, payload: p, valid: v, } = Arbitrator({
                name: key,
                attribute,
                rangeLimits: other,
                disable: isRoot && !checked,
                isRoot: false,
            });
            more.push(elements);
            payload[name] ??= {};
            if (p[key] !== undefined)
                payload[name][key] = p[key];
            valid = valid && v;
        }
    }
    const readableName = toTitleCase(camelCase_to_Sentence(name));
    const options = Object.values(enumeration).filter((e) => typeof e !== 'number');
    if (!disabled && selected)
        payload[name] = enumeration[selected];
    valid = valid && selected !== INITIAL;
    const present = isRoot && _jsx(Checkbox, { checked: checked, onChange: (e) => setChecked(e.target.checked), disabled: disable });
    const control = (_jsx(Autocomplete, { value: selected, options: options, getOptionLabel: (o) => toTitleCase(camelCase_to_Sentence(o)), onChange: (_, v) => setSelected(v), size: "small", disabled: disabled, slots: { popper: AutosizedPopper }, renderInput: (params) => _jsx(AutosizedTextField, { ...params, label: readableName, disabled: disabled, error: !disabled && selected === INITIAL }) }));
    const elements = more.length ? (_jsxs(Stack, { direction: "row", alignItems: "center", gap: 1, children: [present, control, _jsxs(Stack, { gap: 1, children: [...more] })] })) : (_jsxs(Stack, { direction: "row", alignItems: "center", gap: 1, children: [present, control] }));
    return { elements, payload, valid };
};
